<div class="container-404" >
  <div class="title">Oops!</div>
  <div class="subtitle">Looks like you're lost</div>
  <a (click)="goBack()">Go back to Home</a>
</div>
